import React,{useEffect, useRef} from 'react'
import { useState } from 'react'


import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

import { Print } from '@mui/icons-material';

import { Link } from 'react-router-dom';
import portalServices from '../portalServices';
import AppLayout from '../../../layout/components/AppLayout'
import PortalForm from '../components/PortalForm';




function PortalListPage() {

  const [portalList,setPortalList] = useState();
  const [passkey,setPasskey] = useState("");

  const getPortalList = () =>{
    portalServices.getList().then(res=>{
      setPortalList(res.data);

    }).catch(error=>{
      console.log(error);
    })
  }

  const gridRef = useRef();

  const [defaultColDef] = useState({
    floatingFilter: true,
    filterParams: {
      buttons: ['apply'],
    },
    resizable: true,
    width:120,
    filter:true,
    sortable: true,
    editable:true,
    //cellStyle: { 'textTransform': 'uppercase' },
  });


  const [columnDefs,setColumnDef] = useState();
    const prepairColumnDef = () => {
    let _columnDefs = [
        {field:"id",headerName: "ID"},

        
        {field:"portalId",headerName: "PortalId",width:150},
        {field:"url",headerName: "Url",width:350},
        {field:"notificationUrl",headerName: "Notification Url",width:350},
        {field:"minAppVersion",headerName: "App Min Version"},
        {field:"created_at",headerName: "Created On",width:150},
        {field:"updated_at",headerName: "Last Updated on",width:150},
        
    ];
    setColumnDef(_columnDefs);
  }

  
  const onBtnExport = () => {
    gridRef.current.api.exportDataAsCsv("data.csv");
  };

  useEffect(()=>{    
    prepairColumnDef();
  },[]);
  return (
    <AppLayout >
      <div className="container-fluid">
        
        {passkey !== "1122334455" ?
        <div className='row'>
          <div className='col-md-3'></div>
          <div className='col-md-6'>
            <div className='card'>
              <div className='card-header'>PassKey Required</div>
              <div className='card-body'>
                <input type='text' value={passkey} onChange={(e)=>setPasskey(e.target.value)} />
              </div>
            </div>
          </div>
          <div className='col-md-3'></div>
        </div>
        :
        <div className='row'>
          <div className='col-md-6'><h4>Portal</h4></div>
          <div className='col-md-6'> 
            <span className='float-end'><PortalForm callBack={getPortalList} passkey={passkey} /></span>        
            <button className='btn btn-warning me-2 float-end' onClick={onBtnExport} ><Print /> Export </button>
          </div>
        
          <div className='col-md-12 mt-2'>
            <div className="ag-theme-alpine" style={{height: 550}}>
              <AgGridReact
                ref={gridRef}
                rowData={portalList}
                columnDefs={columnDefs}
                defaultColDef={defaultColDef}
                animateRows={true}
                onGridReady={getPortalList}
              />
            </div>
          </div>
        </div>
        }
      </div>
    </AppLayout>
    
  )
}

export default PortalListPage